import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

const KEYS = {
  itemsPerPage: 'components.paginator.itemsPerPageLabel',
  next: 'components.paginator.nextPageLabel',
  previous: 'components.paginator.previousPageLabel',
  of: 'components.paginator.of',
} as const;

/** Подписи mat-paginator из i18n (по умолчанию Material показывает «Items per page» / «of») */
@Injectable()
export class TranslatedPaginatorIntl extends MatPaginatorIntl {
  private ofLabel = 'of';

  constructor() {
    super();
    inject(TranslateService)
      .stream(Object.values(KEYS))
      .pipe(takeUntilDestroyed(inject(DestroyRef)))
      .subscribe((t: Record<string, string>) => {
        this.itemsPerPageLabel = t[KEYS.itemsPerPage];
        this.nextPageLabel = t[KEYS.next];
        this.previousPageLabel = t[KEYS.previous];
        this.ofLabel = t[KEYS.of];
        this.changes.next();
      });
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (!length || !pageSize) return `0 ${this.ofLabel} ${length}`;
    const start = page * pageSize;
    const end = Math.min(start + pageSize, length);
    return `${start + 1}–${end} ${this.ofLabel} ${length}`;
  };
}
